import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

@Injectable()
export class CreditCommonService {

	constructor(
		private configService: ConfigService,
		private requestService: RequestService
	) { }
	
	addCreditApplication(details: any) {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.add.api;
		return this.requestService.post(url, details);
	};

	updateApplication(details: any) {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.edit.api;
		return this.requestService.post(url, details);
	}

	getPaymentTermDto() {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.paymentTerm.api;
		return this.requestService.get(url, {verbose:true})
	};

	getStatusDto() {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.statusCredit.api;
		return this.requestService.get(url, {verbose:true})
	};

	sendEmail(email: any): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').tm.email.send.api;
		return this.requestService.post(url, email);
	};

	getAccountDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url +
        this.configService.get('endpoints').agora.accounts.details.api + '/' + id;
        return this.requestService.get(url);
	};
	getApplicationDetails(id: string): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.details.api + '/' + id;
		return this.requestService.get(url);
	}

	getCreditBuyerEmails(buyerId: string) {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.credit.buyerEmails.api + '/' + buyerId;
		return this.requestService.get(url, { verbose: true })
	}

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/common/services/credit-common.service.ts